export { ListadoEVS } from "./pages/ListadoEVS";

export { CreacionEVS } from "./pages/CreacionEVS";